/**
 * @generated SignedSource<<92885676d0c6fac05bb76450e3285c94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountDataQuery$variables = {
  addresses: ReadonlyArray<string>;
  id?: string | null | undefined;
};
export type accountDataQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"BalanceContextFragment" | "BalancesPoolFragment" | "BorrowAccountFragment" | "GhostVaultAccountFragment" | "IndexAccountFragment" | "IndexBalancesFragment" | "MergingFragment" | "OrderBookAccountFragment" | "PortfolioFragment" | "PositionsPortfolioFragment" | "StrategyAccountFragment" | "ThorchainPoolAccountFragment" | "TradeSubscriptionsFragment" | "useAutoClaimerFragment">;
  } | null | undefined;
};
export type accountDataQuery = {
  response: accountDataQuery$data;
  variables: accountDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addresses"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v5 = [
  {
    "kind": "Variable",
    "name": "addresses",
    "variableName": "addresses"
  },
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asset",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chain",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decimals",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueUsd",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Denom",
  "kind": "LinkedField",
  "name": "native",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "denom",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetVariants",
  "kind": "LinkedField",
  "name": "variants",
  "plural": false,
  "selections": [
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v13/*: any*/),
  (v18/*: any*/),
  (v6/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v27 = [
  (v26/*: any*/),
  (v6/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "BowPool",
  "kind": "LinkedField",
  "name": "pool",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "x",
              "plural": false,
              "selections": (v27/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "y",
              "plural": false,
              "selections": (v27/*: any*/),
              "storageKey": null
            }
          ],
          "type": "BowConfigXyk",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Price",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Balance",
  "kind": "LinkedField",
  "name": "value",
  "plural": true,
  "selections": [
    (v29/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "asset",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v26/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetVariants",
  "kind": "LinkedField",
  "name": "variants",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "secured",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v10/*: any*/),
        (v8/*: any*/),
        (v32/*: any*/),
        (v18/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v8/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v6/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v36 = [
  (v29/*: any*/),
  (v35/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetRedeemValue",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "runeRedeemValue",
  "storageKey": null
},
v39 = [
  (v15/*: any*/),
  (v29/*: any*/),
  (v35/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v42 = [
  (v40/*: any*/),
  (v41/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v26/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "Apr",
  "kind": "LinkedField",
  "name": "apr",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v45 = [
  (v44/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharesValue",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v48 = [
  (v29/*: any*/),
  (v47/*: any*/)
],
v49 = [
  (v29/*: any*/)
],
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v51 = [
  (v4/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "RujiraAccount",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "GhostCreditCollateral",
  "kind": "LinkedField",
  "name": "collaterals",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "collateral",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "asset",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v26/*: any*/),
                (v6/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v18/*: any*/)
              ],
              "storageKey": null
            },
            (v29/*: any*/)
          ],
          "type": "Balance",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueFull",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueAdjusted",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "GhostCreditDebt",
  "kind": "LinkedField",
  "name": "debts",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GhostVaultDelegate",
      "kind": "LinkedField",
      "name": "debt",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GhostVaultBorrower",
          "kind": "LinkedField",
          "name": "borrower",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GhostVault",
              "kind": "LinkedField",
              "name": "vault",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GhostVaultStatus",
                  "kind": "LinkedField",
                  "name": "status",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "debtRate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Asset",
              "kind": "LinkedField",
              "name": "asset",
              "plural": false,
              "selections": [
                (v26/*: any*/),
                (v6/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v18/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ltv",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shares",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remaining",
  "storageKey": null
},
v60 = [
  (v8/*: any*/),
  (v10/*: any*/),
  (v9/*: any*/),
  (v13/*: any*/),
  (v6/*: any*/)
],
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v63 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Asset",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v32/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetVariants",
        "kind": "LinkedField",
        "name": "variants",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "secured",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v29/*: any*/)
],
v64 = {
  "alias": "previousTime",
  "args": null,
  "kind": "ScalarField",
  "name": "previous",
  "storageKey": null
},
v65 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  },
  {
    "kind": "Literal",
    "name": "states",
    "value": [
      "RUNNING"
    ]
  }
],
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BalanceContextFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BalancesPoolFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BorrowAccountFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GhostVaultAccountFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IndexAccountFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IndexBalancesFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MergingFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OrderBookAccountFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PortfolioFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PositionsPortfolioFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StrategyAccountFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ThorchainPoolAccountFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TradeSubscriptionsFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useAutoClaimerFragment"
              }
            ],
            "type": "Account",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "accountDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "BalanceV2Connection",
                "kind": "LinkedField",
                "name": "balancesV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BalanceV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BalanceV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Price",
                                "kind": "LinkedField",
                                "name": "price",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "changeDay",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BalanceV2Account",
                            "kind": "LinkedField",
                            "name": "accounts",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v7/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Asset",
                                "kind": "LinkedField",
                                "name": "asset",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": [
                  "addresses"
                ],
                "handle": "connection",
                "key": "BalanceContext_balancesV2",
                "kind": "LinkedHandle",
                "name": "balancesV2"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BowAccount",
                "kind": "LinkedField",
                "name": "bow",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v25/*: any*/),
                  (v28/*: any*/),
                  (v31/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Balance",
                    "kind": "LinkedField",
                    "name": "shares",
                    "plural": false,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "strategies",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v26/*: any*/),
                          (v30/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "ThorchainLiquidityProvider",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v15/*: any*/),
                      (v31/*: any*/)
                    ],
                    "type": "BowAccount",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "lpSize",
                        "plural": false,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "xlpSize",
                        "plural": false,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PerpsPool",
                        "kind": "LinkedField",
                        "name": "pool",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "baseAsset",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "quoteAsset",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PerpsStats",
                            "kind": "LinkedField",
                            "name": "stats",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Apr",
                                "kind": "LinkedField",
                                "name": "lpApr",
                                "plural": false,
                                "selections": (v42/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lpShares",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "xlpShares",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "availableYieldLp",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          (v43/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "availableYieldXlp",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PerpsLiquidityCooldown",
                        "kind": "LinkedField",
                        "name": "liquidityCooldown",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PerpsAccount",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndexVault",
                        "kind": "LinkedField",
                        "name": "index",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "shareAsset",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IndexStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v45/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndexAllocation",
                        "kind": "LinkedField",
                        "name": "allocations",
                        "plural": true,
                        "selections": [
                          (v47/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "IndexAccount",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StakingPool",
                        "kind": "LinkedField",
                        "name": "pool",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "bondAsset",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v6/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StakingSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "revenueAsset",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "receiptAsset",
                            "plural": false,
                            "selections": (v34/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "bonded",
                        "plural": false,
                        "selections": (v48/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "liquidSize",
                        "plural": false,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "pendingRevenue",
                        "plural": false,
                        "selections": (v48/*: any*/),
                        "storageKey": null
                      },
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "liquidShares",
                        "plural": false,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "StakingAccount",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GhostVault",
                        "kind": "LinkedField",
                        "name": "vault",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v6/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": "receiptValue",
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              (v13/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "receiptShares",
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "shares",
                        "plural": false,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "GhostVaultAccount",
                    "abstractKey": null
                  },
                  (v50/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GhostCreditAccounts",
                "kind": "LinkedField",
                "name": "credit",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GhostCreditAccountNext",
                    "kind": "LinkedField",
                    "name": "next",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "salt",
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v51/*: any*/),
                    "concreteType": "GhostCreditAccountConnection",
                    "kind": "LinkedField",
                    "name": "accountsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GhostCreditAccountEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GhostCreditAccount",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v6/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": "accountsV2(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v51/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Borrow_accountsV2",
                    "kind": "LinkedHandle",
                    "name": "accountsV2"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GhostCreditAccount",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v15/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IndexAccount",
                "kind": "LinkedField",
                "name": "index",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndexVault",
                    "kind": "LinkedField",
                    "name": "index",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "shareAsset",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndexFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IndexFeesRates",
                            "kind": "LinkedField",
                            "name": "rates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "transaction",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/),
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MergeStats",
                "kind": "LinkedField",
                "name": "merge",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MergeAccount",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "merged",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v13/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v58/*: any*/),
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Metadata",
                                "kind": "LinkedField",
                                "name": "metadata",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v30/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MergePool",
                        "kind": "LinkedField",
                        "name": "pool",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MergeStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v45/*: any*/),
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Balance",
                    "kind": "LinkedField",
                    "name": "totalSize",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v30/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinAccount",
                "kind": "LinkedField",
                "name": "fin",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v51/*: any*/),
                    "concreteType": "FinOrderConnection",
                    "kind": "LinkedField",
                    "name": "orders",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinOrderEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinOrder",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinPair",
                                "kind": "LinkedField",
                                "name": "pair",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v58/*: any*/),
                              (v59/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "orders(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v51/*: any*/),
                    "concreteType": "OrderConnection",
                    "kind": "LinkedField",
                    "name": "ordersV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinPair",
                                    "kind": "LinkedField",
                                    "name": "pair",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Asset",
                                        "kind": "LinkedField",
                                        "name": "assetBase",
                                        "plural": false,
                                        "selections": (v60/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Asset",
                                        "kind": "LinkedField",
                                        "name": "assetQuote",
                                        "plural": false,
                                        "selections": (v60/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FinBook",
                                        "kind": "LinkedField",
                                        "name": "book",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "center",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "side",
                                    "storageKey": null
                                  },
                                  (v58/*: any*/),
                                  (v9/*: any*/),
                                  (v61/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "deviation",
                                    "storageKey": null
                                  },
                                  (v59/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "filled",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "filledValue",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "filledFee",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "offer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingValue",
                                    "storageKey": null
                                  },
                                  (v62/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "offerValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "FinOrder",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Balance",
                                    "kind": "LinkedField",
                                    "name": "balances",
                                    "plural": true,
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Asset",
                                        "kind": "LinkedField",
                                        "name": "asset",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v13/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssetVariants",
                                            "kind": "LinkedField",
                                            "name": "variants",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Asset",
                                                "kind": "LinkedField",
                                                "name": "secured",
                                                "plural": false,
                                                "selections": [
                                                  (v9/*: any*/),
                                                  (v10/*: any*/),
                                                  (v13/*: any*/),
                                                  (v18/*: any*/),
                                                  (v6/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  (v16/*: any*/),
                                  (v52/*: any*/),
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "source",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  },
                                  (v62/*: any*/),
                                  (v61/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CalcOrderConfig",
                                    "kind": "LinkedField",
                                    "name": "config",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "next",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "denoms",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CalcDestination",
                                                        "kind": "LinkedField",
                                                        "name": "destinations",
                                                        "plural": true,
                                                        "selections": [
                                                          (v57/*: any*/),
                                                          (v52/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "recipient",
                                                            "plural": false,
                                                            "selections": [
                                                              (v3/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v16/*: any*/)
                                                                ],
                                                                "type": "CalcRecipientBank",
                                                                "abstractKey": null
                                                              },
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v16/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "msg",
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "type": "CalcRecipientContract",
                                                                "abstractKey": null
                                                              },
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "memo",
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "type": "CalcRecipientDeposit",
                                                                "abstractKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "CalcActionDistribute",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Balance",
                                                        "kind": "LinkedField",
                                                        "name": "swapAmount",
                                                        "plural": false,
                                                        "selections": (v63/*: any*/),
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Balance",
                                                        "kind": "LinkedField",
                                                        "name": "minimumReceiveAmount",
                                                        "plural": false,
                                                        "selections": (v63/*: any*/),
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "adjustment",
                                                        "plural": false,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "kind",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "type": "CalcSwapAmountAdjustmentFixed",
                                                            "abstractKey": null
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Balance",
                                                                "kind": "LinkedField",
                                                                "name": "baseReceiveAmount",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v29/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Asset",
                                                                    "kind": "LinkedField",
                                                                    "name": "asset",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v18/*: any*/),
                                                                      (v6/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "scalar",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "type": "CalcSwapAmountAdjustmentLinearScalar",
                                                            "abstractKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "routes",
                                                        "plural": true,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "pairAddress",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "type": "CalcSwapRouteFin",
                                                            "abstractKey": null
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "affiliateCode",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "affiliateBps",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "type": "CalcSwapRouteThorchain",
                                                            "abstractKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "maximumSlippageBps",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "CalcActionSwap",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CalcAction",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "condition",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "timestamp",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "CalcConditionTimestampElapsed",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "cadence",
                                                        "plural": false,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "expr",
                                                                "storageKey": null
                                                              },
                                                              (v64/*: any*/)
                                                            ],
                                                            "type": "CalcCadenceCron",
                                                            "abstractKey": null
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "duration",
                                                                "storageKey": null
                                                              },
                                                              (v64/*: any*/)
                                                            ],
                                                            "type": "CalcCadenceTime",
                                                            "abstractKey": null
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "interval",
                                                                "storageKey": null
                                                              },
                                                              {
                                                                "alias": "previousBlock",
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "previous",
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "type": "CalcCadenceBlocks",
                                                            "abstractKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "executors",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "executions",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "jitter",
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "CalcConditionSchedule",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v16/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Balance",
                                                        "kind": "LinkedField",
                                                        "name": "amount",
                                                        "plural": false,
                                                        "selections": (v48/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "type": "CalcConditionBalanceAvailable",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "CalcCondition",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CalcOrder",
                                "abstractKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": "ordersV2(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v51/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "TradeSubscriptionsFragment_ordersV2",
                    "kind": "LinkedHandle",
                    "name": "ordersV2"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StakingAccounts",
                "kind": "LinkedField",
                "name": "staking",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StakingAccount",
                    "kind": "LinkedField",
                    "name": "single",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "bonded",
                        "plural": false,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Balance",
                        "kind": "LinkedField",
                        "name": "liquid",
                        "plural": false,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ThorchainLiquidityProvider",
                "kind": "LinkedField",
                "name": "liquidityAccounts",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v30/*: any*/),
                      (v13/*: any*/),
                      (v10/*: any*/),
                      (v9/*: any*/),
                      (v8/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "units",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assetAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "runeAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pendingAsset",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pendingRune",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutoAccount",
                "kind": "LinkedField",
                "name": "auto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v65/*: any*/),
                    "concreteType": "AutoWorkflowInstanceConnection",
                    "kind": "LinkedField",
                    "name": "workflows",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutoWorkflowInstanceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AutoWorkflowInstance",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "instanceId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "workflowId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requester",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "executionType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cronExpression",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "onchainParameters",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "offchainParameters",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expirationDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "launcherId",
                                "storageKey": null
                              },
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AutoWorkflow",
                                "kind": "LinkedField",
                                "name": "workflow",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AutoWorkflowSchedule",
                                "kind": "LinkedField",
                                "name": "schedule",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nextExecutionTimes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "runningWorkflows",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AutoWorkflowRun",
                                "kind": "LinkedField",
                                "name": "lastRun",
                                "plural": false,
                                "selections": [
                                  (v66/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startTime",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endTime",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": "workflows(first:100000,states:[\"RUNNING\"])"
                  },
                  {
                    "alias": null,
                    "args": (v65/*: any*/),
                    "filters": [
                      "states"
                    ],
                    "handle": "connection",
                    "key": "useAutoClaimerFragment_workflows",
                    "kind": "LinkedHandle",
                    "name": "workflows"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Account",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1252e62b47f35380e4a8b60f15253d21",
    "id": null,
    "metadata": {},
    "name": "accountDataQuery",
    "operationKind": "query",
    "text": "query accountDataQuery(\n  $id: ID\n  $addresses: [Address!]!\n) {\n  node(id: $id) {\n    __typename\n    ... on Account {\n      ...BalanceContextFragment\n      ...BalancesPoolFragment\n      ...BorrowAccountFragment\n      ...GhostVaultAccountFragment\n      ...IndexAccountFragment\n      ...IndexBalancesFragment\n      ...MergingFragment\n      ...OrderBookAccountFragment\n      ...PortfolioFragment\n      ...PositionsPortfolioFragment\n      ...StrategyAccountFragment\n      ...ThorchainPoolAccountFragment\n      ...TradeSubscriptionsFragment\n      ...useAutoClaimerFragment\n    }\n    id\n  }\n}\n\nfragment ActionsAccountFragment on Account {\n  index {\n    id\n    shares\n    index {\n      id\n      address\n      shareAsset {\n        asset\n        id\n      }\n      fees {\n        rates {\n          transaction\n        }\n      }\n    }\n  }\n}\n\nfragment BalanceContextFragment on Account {\n  balancesV2(first: 100, addresses: $addresses) {\n    edges {\n      node {\n        id\n        balance\n        asset {\n          id\n          asset\n          type\n          chain\n          metadata {\n            symbol\n            decimals\n          }\n          price {\n            current\n            changeDay\n            id\n          }\n        }\n        valueUsd\n        accounts {\n          address\n          balance\n          valueUsd\n          asset {\n            asset\n            type\n            chain\n            metadata {\n              symbol\n              decimals\n            }\n            variants {\n              native {\n                denom\n              }\n            }\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BalanceThumbDualFragment on BowAccount {\n  id\n  account\n  pool {\n    config {\n      __typename\n      ... on BowConfigXyk {\n        x {\n          metadata {\n            symbol\n          }\n          id\n        }\n        y {\n          metadata {\n            symbol\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  value {\n    amount\n    asset {\n      price {\n        current\n        id\n      }\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n  valueUsd\n  ...BowPoolXykBalanceWithdrawFragment\n}\n\nfragment BalancesPoolFragment on Account {\n  bow {\n    id\n    ...BalanceThumbDualFragment\n  }\n  strategies {\n    __typename\n    ... on ThorchainLiquidityProvider {\n      id\n      ...ThorchainPoolThumbFragment\n    }\n    ... on BowAccount {\n      id\n      ...BowPoolXykThumbFragment\n    }\n    ... on PerpsAccount {\n      id\n      ...PerpsPoolThumbFragment\n    }\n    ... on IndexAccount {\n      id\n      ...IndexVaultThumbFragment\n      ...IndexVaultPortfolioRowFragment\n    }\n    ... on StakingAccount {\n      id\n      ...StakingPoolThumbFragment\n      ...StakingPoolPortfolioRowFragment\n    }\n    ... on GhostVaultAccount {\n      id\n      ...GhostVaultThumbFragment\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment BorrowAccountFragment on Account {\n  credit {\n    next {\n      salt\n      account\n    }\n    accountsV2(first: 100) {\n      edges {\n        node {\n          account {\n            address\n          }\n          ...PositionBorrowRowFragment\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment BowPoolXykAccountFragment on Account {\n  address\n  bow {\n    id\n    ...BowPoolXykBalanceFragment\n  }\n}\n\nfragment BowPoolXykBalanceFragment on BowAccount {\n  id\n  account\n  shares {\n    amount\n    asset {\n      ...msgAssetFragment\n      id\n    }\n  }\n  value {\n    amount\n    asset {\n      price {\n        current\n        id\n      }\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n  valueUsd\n  ...BowPoolXykBalanceWithdrawFragment\n}\n\nfragment BowPoolXykBalanceWithdrawFragment on BowAccount {\n  shares {\n    amount\n    asset {\n      ...msgAssetFragment\n      id\n    }\n  }\n  value {\n    amount\n    asset {\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n}\n\nfragment BowPoolXykThumbFragment on BowAccount {\n  id\n  account\n  pool {\n    config {\n      __typename\n      ... on BowConfigXyk {\n        x {\n          metadata {\n            symbol\n          }\n          id\n        }\n        y {\n          metadata {\n            symbol\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  valueUsd\n  value {\n    amount\n    asset {\n      price {\n        current\n        id\n      }\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n}\n\nfragment GhostVaultAccountFragment on Account {\n  address\n  strategies {\n    __typename\n    ... on GhostVaultAccount {\n      id\n      ...GhostVaultBalanceFragment\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment GhostVaultBalanceFragment on GhostVaultAccount {\n  id\n  account\n  receiptShares: shares {\n    amount\n    asset {\n      ...msgAssetFragment\n      id\n    }\n  }\n  receiptValue: value {\n    amount\n    asset {\n      price {\n        current\n        id\n      }\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n  valueUsd\n  ...GhostVaultBalanceWithdrawFragment\n}\n\nfragment GhostVaultBalanceWithdrawFragment on GhostVaultAccount {\n  vault {\n    address\n    id\n  }\n  receiptShares: shares {\n    amount\n    asset {\n      ...msgAssetFragment\n      id\n    }\n  }\n  receiptValue: value {\n    amount\n    asset {\n      metadata {\n        symbol\n        decimals\n      }\n      id\n    }\n  }\n}\n\nfragment GhostVaultThumbFragment on GhostVaultAccount {\n  id\n  account\n  vault {\n    asset {\n      asset\n      metadata {\n        symbol\n      }\n      id\n    }\n    id\n  }\n  valueUsd\n  receiptValue: value {\n    amount\n    asset {\n      price {\n        current\n        id\n      }\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n}\n\nfragment IndexAccountFragment on Account {\n  ...ActionsAccountFragment\n  ...IndexBalancesFragment\n  ...ShareCardBadgeAccountFragment\n}\n\nfragment IndexBalanceFragment on IndexAccount {\n  sharesValue\n  shares\n  account\n  index {\n    id\n    shareAsset {\n      ...msgAssetFragment\n      asset\n      metadata {\n        decimals\n        symbol\n      }\n      id\n    }\n  }\n}\n\nfragment IndexBalancesFragment on Account {\n  index {\n    id\n    ...IndexBalanceFragment\n  }\n}\n\nfragment IndexVaultPortfolioRowFragment on IndexAccount {\n  id\n  index {\n    id\n    type\n    shareAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    status {\n      apr {\n        value\n        status\n      }\n    }\n  }\n  sharesValue\n  allocations {\n    asset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    balance\n  }\n}\n\nfragment IndexVaultThumbFragment on IndexAccount {\n  id\n  index {\n    shareAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    id\n  }\n  sharesValue\n}\n\nfragment LimitOrdersFragment on FinOrder {\n  deviation\n  filled\n  filledValue\n  filledFee\n  offer\n  owner\n  pair {\n    address\n    assetBase {\n      asset\n      chain\n      type\n      metadata {\n        symbol\n        decimals\n      }\n      id\n    }\n    assetQuote {\n      asset\n      chain\n      type\n      metadata {\n        symbol\n        decimals\n      }\n      id\n    }\n    book {\n      id\n      center\n    }\n    id\n  }\n  remaining\n  remainingValue\n  rate\n  side\n  type\n  updatedAt\n  offerValue\n}\n\nfragment MergePortfolioAccountFragment on Account {\n  merge {\n    totalSize {\n      amount\n      asset {\n        metadata {\n          symbol\n        }\n        price {\n          current\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MergingFragment on Account {\n  merge {\n    accounts {\n      merged {\n        amount\n        asset {\n          asset\n          metadata {\n            symbol\n            decimals\n          }\n          id\n        }\n      }\n      rate\n      shares\n      size {\n        amount\n        asset {\n          asset\n          metadata {\n            decimals\n          }\n          price {\n            current\n            id\n          }\n          id\n        }\n      }\n      valueUsd\n      pool {\n        status {\n          apr {\n            value\n            status\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment OrderBookAccountFragment on Account {\n  fin {\n    orders(first: 100) {\n      edges {\n        node {\n          pair {\n            address\n            id\n          }\n          rate\n          remaining\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PerpsPoolAccountFragment on Account {\n  address\n  strategies {\n    __typename\n    ... on PerpsAccount {\n      ...PerpsPoolBalanceFragment\n      account\n      pool {\n        address\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment PerpsPoolBalanceFragment on PerpsAccount {\n  id\n  account\n  lpSize {\n    amount\n    asset {\n      ...msgAssetFragment\n      metadata {\n        symbol\n      }\n      id\n    }\n    valueUsd\n  }\n  lpShares\n  xlpSize {\n    amount\n    asset {\n      ...msgAssetFragment\n      metadata {\n        symbol\n      }\n      id\n    }\n    valueUsd\n  }\n  xlpShares\n  availableYieldLp {\n    amount\n    asset {\n      asset\n      metadata {\n        symbol\n      }\n      id\n    }\n    valueUsd\n  }\n  availableYieldXlp {\n    amount\n    asset {\n      asset\n      id\n    }\n    valueUsd\n  }\n  ...PerpsPoolBalanceReinvestFragment\n  ...PerpsPoolBalanceWithdrawFragment\n}\n\nfragment PerpsPoolBalanceReinvestFragment on PerpsAccount {\n  id\n  availableYieldLp {\n    amount\n  }\n  availableYieldXlp {\n    amount\n  }\n}\n\nfragment PerpsPoolBalanceWithdrawFragment on PerpsAccount {\n  id\n  lpSize {\n    amount\n  }\n  liquidityCooldown {\n    endAt\n    startAt\n  }\n}\n\nfragment PerpsPoolThumbFragment on PerpsAccount {\n  id\n  lpSize {\n    valueUsd\n  }\n  xlpSize {\n    valueUsd\n  }\n  pool {\n    baseAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    quoteAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    stats {\n      lpApr {\n        value\n        status\n      }\n    }\n    id\n  }\n}\n\nfragment PortfolioFragment on Account {\n  ...MergePortfolioAccountFragment\n  fin {\n    ordersV2(first: 100) {\n      edges {\n        cursor\n        node {\n          __typename\n          ... on FinOrder {\n            valueUsd\n          }\n          ... on CalcOrder {\n            valueUsd\n            balances {\n              amount\n            }\n            ...RecurringOrdersFragment\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  merge {\n    accounts {\n      merged {\n        amount\n      }\n      valueUsd\n      id\n    }\n  }\n  staking {\n    single {\n      bonded {\n        amount\n      }\n      liquid {\n        amount\n      }\n      id\n    }\n  }\n  credit {\n    accounts {\n      id\n      valueUsd\n    }\n  }\n  strategies {\n    __typename\n    ... on ThorchainLiquidityProvider {\n      id\n      valueUsd\n    }\n    ... on BowAccount {\n      id\n      valueUsd\n    }\n    ... on StakingAccount {\n      id\n      valueUsd\n    }\n    ... on PerpsAccount {\n      id\n      valueUsd\n    }\n    ... on IndexAccount {\n      id\n      sharesValue\n    }\n    ... on GhostVaultAccount {\n      id\n      valueUsd\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment PositionBorrowFragment on GhostCreditAccount {\n  id\n  account {\n    address\n    label\n  }\n  ...PositionPositionFragment\n}\n\nfragment PositionBorrowRowFragment on GhostCreditAccount {\n  account {\n    address\n    label\n  }\n  collaterals {\n    collateral {\n      __typename\n      ... on Balance {\n        asset {\n          asset\n          metadata {\n            symbol\n          }\n          id\n        }\n        amount\n      }\n    }\n    valueFull\n    valueAdjusted\n  }\n  debts {\n    value\n    debt {\n      current\n      borrower {\n        vault {\n          status {\n            debtRate\n          }\n          id\n        }\n        asset {\n          metadata {\n            symbol\n          }\n          id\n        }\n      }\n    }\n  }\n  ltv\n  ...PositionBorrowFragment\n}\n\nfragment PositionPositionFragment on GhostCreditAccount {\n  collaterals {\n    collateral {\n      __typename\n      ... on Balance {\n        asset {\n          asset\n          type\n          chain\n          metadata {\n            symbol\n          }\n          variants {\n            native {\n              denom\n            }\n          }\n          id\n        }\n        amount\n      }\n    }\n    valueFull\n    valueAdjusted\n  }\n  debts {\n    value\n    debt {\n      current\n      borrower {\n        vault {\n          status {\n            debtRate\n          }\n          id\n        }\n        asset {\n          asset\n          type\n          chain\n          metadata {\n            symbol\n          }\n          variants {\n            native {\n              denom\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n  ltv\n}\n\nfragment PositionsPortfolioFragment on Account {\n  credit {\n    accounts {\n      account {\n        address\n      }\n      ...PositionBorrowRowFragment\n      id\n    }\n  }\n}\n\nfragment RecurringOrdersFragment on CalcOrder {\n  id\n  address\n  label\n  status\n  source\n  createdAt\n  updatedAt\n  owner\n  balances {\n    asset {\n      type\n      chain\n      metadata {\n        symbol\n        decimals\n      }\n      variants {\n        native {\n          denom\n        }\n        secured {\n          type\n          chain\n          metadata {\n            symbol\n            decimals\n          }\n          variants {\n            native {\n              denom\n            }\n          }\n          id\n        }\n      }\n      id\n    }\n    amount\n  }\n  config {\n    nodes {\n      __typename\n      ... on CalcAction {\n        next\n        action {\n          __typename\n          ... on CalcActionDistribute {\n            denoms\n            destinations {\n              shares\n              label\n              recipient {\n                __typename\n                ... on CalcRecipientBank {\n                  address\n                }\n                ... on CalcRecipientContract {\n                  address\n                  msg\n                }\n                ... on CalcRecipientDeposit {\n                  memo\n                }\n              }\n            }\n          }\n          ... on CalcActionSwap {\n            swapAmount {\n              asset {\n                type\n                chain\n                asset\n                metadata {\n                  decimals\n                  symbol\n                }\n                variants {\n                  native {\n                    denom\n                  }\n                  secured {\n                    asset\n                    type\n                    chain\n                    metadata {\n                      symbol\n                      decimals\n                    }\n                    variants {\n                      native {\n                        denom\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              amount\n            }\n            minimumReceiveAmount {\n              asset {\n                type\n                chain\n                asset\n                metadata {\n                  decimals\n                  symbol\n                }\n                variants {\n                  native {\n                    denom\n                  }\n                  secured {\n                    asset\n                    type\n                    chain\n                    metadata {\n                      symbol\n                      decimals\n                    }\n                    variants {\n                      native {\n                        denom\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              amount\n            }\n            adjustment {\n              __typename\n              ... on CalcSwapAmountAdjustmentFixed {\n                kind\n              }\n              ... on CalcSwapAmountAdjustmentLinearScalar {\n                baseReceiveAmount {\n                  amount\n                  asset {\n                    variants {\n                      native {\n                        denom\n                      }\n                    }\n                    id\n                  }\n                }\n                scalar\n              }\n            }\n            routes {\n              __typename\n              ... on CalcSwapRouteFin {\n                pairAddress\n              }\n              ... on CalcSwapRouteThorchain {\n                affiliateCode\n                affiliateBps\n              }\n            }\n            maximumSlippageBps\n          }\n        }\n      }\n      ... on CalcCondition {\n        condition {\n          __typename\n          ... on CalcConditionTimestampElapsed {\n            timestamp\n          }\n          ... on CalcConditionSchedule {\n            cadence {\n              __typename\n              ... on CalcCadenceCron {\n                expr\n                previousTime: previous\n              }\n              ... on CalcCadenceTime {\n                duration\n                previousTime: previous\n              }\n              ... on CalcCadenceBlocks {\n                interval\n                previousBlock: previous\n              }\n            }\n            executors\n            executions\n            jitter\n          }\n          ... on CalcConditionBalanceAvailable {\n            address\n            amount {\n              amount\n              asset {\n                metadata {\n                  symbol\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ShareCardBadgeAccountFragment on Account {\n  index {\n    sharesValue\n    index {\n      id\n    }\n    id\n  }\n}\n\nfragment StakingPoolBalanceFragment on StakingAccount {\n  id\n  account\n  liquidSize {\n    amount\n    asset {\n      ...msgAssetFragment\n      id\n    }\n  }\n  bonded {\n    amount\n  }\n  valueUsd\n  pool {\n    bondAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    id\n  }\n  ...StakingPoolBalanceWithdrawFragment\n  ...StakingPoolBalanceRewardsFragment\n  ...StakingPoolBalanceTransferFragment\n}\n\nfragment StakingPoolBalanceRewardsFragment on StakingAccount {\n  pool {\n    address\n    revenueAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    id\n  }\n  pendingRevenue {\n    amount\n  }\n}\n\nfragment StakingPoolBalanceTransferFragment on StakingAccount {\n  pool {\n    bondAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    receiptAsset {\n      ...msgAssetFragment\n      metadata {\n        symbol\n      }\n      id\n    }\n    id\n  }\n  liquidSize {\n    amount\n  }\n  liquidShares {\n    amount\n  }\n}\n\nfragment StakingPoolBalanceWithdrawFragment on StakingAccount {\n  pool {\n    address\n    bondAsset {\n      variants {\n        native {\n          denom\n        }\n      }\n      id\n    }\n    id\n  }\n  bonded {\n    amount\n    asset {\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n  liquidSize {\n    amount\n  }\n  liquidShares {\n    amount\n  }\n}\n\nfragment StakingPoolPageAccountFragment on Account {\n  strategies {\n    __typename\n    ... on StakingAccount {\n      pool {\n        id\n      }\n      ...StakingPoolBalanceFragment\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StakingPoolPortfolioRowFragment on StakingAccount {\n  id\n  pool {\n    bondAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    summary {\n      apr {\n        value\n        status\n      }\n      id\n    }\n    id\n  }\n  bonded {\n    amount\n  }\n  liquidSize {\n    amount\n  }\n  pendingRevenue {\n    amount\n    asset {\n      metadata {\n        symbol\n      }\n      id\n    }\n  }\n  valueUsd\n}\n\nfragment StakingPoolThumbFragment on StakingAccount {\n  id\n  pool {\n    bondAsset {\n      metadata {\n        symbol\n      }\n      id\n    }\n    id\n  }\n  valueUsd\n}\n\nfragment StrategyAccountFragment on Account {\n  ...BowPoolXykAccountFragment\n  ...PerpsPoolAccountFragment\n  ...ThorchainPoolAccountFragment\n  ...StakingPoolPageAccountFragment\n}\n\nfragment ThorchainPoolAccountFragment on Account {\n  liquidityAccounts {\n    id\n    asset {\n      id\n    }\n    ...ThorchainPoolBalanceFragment\n    ...ThorchainPoolDepositAccountFragment\n  }\n}\n\nfragment ThorchainPoolBalanceFragment on ThorchainLiquidityProvider {\n  id\n  asset {\n    price {\n      current\n      id\n    }\n    metadata {\n      symbol\n    }\n    id\n  }\n  assetRedeemValue\n  runeRedeemValue\n  units\n  valueUsd\n  ...ThorchainPoolBalanceWithDrawFragment\n}\n\nfragment ThorchainPoolBalanceWithDrawFragment on ThorchainLiquidityProvider {\n  assetAddress\n  runeAddress\n  asset {\n    chain\n    metadata {\n      symbol\n    }\n    ...msgAssetFragment\n    id\n  }\n  units\n  runeRedeemValue\n  assetRedeemValue\n}\n\nfragment ThorchainPoolDepositAccountFragment on ThorchainLiquidityProvider {\n  pendingAsset\n  pendingRune\n}\n\nfragment ThorchainPoolThumbFragment on ThorchainLiquidityProvider {\n  asset {\n    asset\n    metadata {\n      symbol\n    }\n    price {\n      current\n      id\n    }\n    id\n  }\n  valueUsd\n  assetRedeemValue\n  runeRedeemValue\n}\n\nfragment TradeSubscriptionsFragment on Account {\n  address\n  fin {\n    ordersV2(first: 100) {\n      edges {\n        node {\n          __typename\n          ... on FinOrder {\n            pair {\n              address\n              id\n            }\n            side\n            rate\n            type\n            owner\n            deviation\n            remaining\n            filled\n            ...LimitOrdersFragment\n          }\n          ... on CalcOrder {\n            id\n            updatedAt\n            valueUsd\n            source\n            status\n            balances {\n              amount\n            }\n            config {\n              nodes {\n                __typename\n                ... on CalcAction {\n                  action {\n                    __typename\n                    ... on CalcActionSwap {\n                      routes {\n                        __typename\n                        ... on CalcSwapRouteFin {\n                          pairAddress\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            ...RecurringOrdersFragment\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment msgAssetFragment on Asset {\n  type\n  chain\n  asset\n  metadata {\n    decimals\n    symbol\n  }\n  variants {\n    native {\n      denom\n    }\n    secured {\n      type\n      chain\n      asset\n      metadata {\n        decimals\n        symbol\n      }\n      variants {\n        native {\n          denom\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment useAutoClaimerFragment on Account {\n  address\n  auto {\n    workflows(states: [\"RUNNING\"], first: 100000) {\n      edges {\n        node {\n          id\n          instanceId\n          workflowId\n          requester\n          executionType\n          cronExpression\n          onchainParameters\n          offchainParameters\n          expirationDate\n          launcherId\n          state\n          workflow {\n            id\n            name\n          }\n          schedule {\n            status\n            nextExecutionTimes\n            runningWorkflows\n          }\n          lastRun {\n            state\n            startTime\n            endTime\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ae569327a43279e14e5950389a64782";

export default node;
